export const initAHrefLightbox = () => {
	document.addEventListener(`click`, (evt) => {
		if ( /#lightbox/.test(evt.target.getAttribute(`href`) ) )
		{
			evt.preventDefault();
			location.hash = evt.target.hash;
		}
	});
};
